var map = {
	"./JointConsultation.js": 98939,
	"./accompany.js": 94041,
	"./activity.js": 68450,
	"./adapter.js": 55975,
	"./adviser.js": 82051,
	"./agedUse.js": 3404,
	"./aiChat.js": 47241,
	"./app.js": 14691,
	"./ask.js": 87869,
	"./ask2.js": 67261,
	"./authAdapter.js": 44754,
	"./ccbMember.js": 64891,
	"./chronicDisease.js": 66249,
	"./clinic.js": 21884,
	"./common.js": 88227,
	"./cspg.js": 72061,
	"./doctor.js": 6580,
	"./eyeOrMouse.js": 79769,
	"./familyDoctor.js": 24941,
	"./famousDoc.js": 50952,
	"./flowers.js": 36822,
	"./guidance.js": 32387,
	"./healthrecord.js": 25123,
	"./home.js": 80986,
	"./houserecovery.js": 76933,
	"./inspection.js": 14189,
	"./insurance.js": 742,
	"./live.js": 90294,
	"./longRange.js": 57278,
	"./newOperation.js": 37141,
	"./nurse.js": 63979,
	"./operation.js": 89362,
	"./orgService.js": 27976,
	"./overtimeClinic.js": 36657,
	"./patient.js": 53894,
	"./patientReport.js": 30455,
	"./physicalExamination.js": 48485,
	"./plusRegistration.js": 32233,
	"./privately.js": 10216,
	"./quickExamination.js": 85538,
	"./redirect.js": 34301,
	"./register.js": 82249,
	"./registration.js": 84172,
	"./report.js": 44439,
	"./rsquo.js": 47983,
	"./saTCM.js": 72610,
	"./showCode.js": 68117,
	"./special-disease.js": 36644,
	"./special.js": 78422,
	"./symptom.js": 57026,
	"./teamPhysicalExamination.js": 7538,
	"./ticket.js": 65914,
	"./train.js": 13981,
	"./transfer.js": 37680,
	"./ucenter.js": 91437,
	"./voice.js": 33716,
	"./yunnancn.js": 3713
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61355;